import React, { useEffect, useState, useMemo, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useSetLoading } from "../../../../common/hooks/appearance";
import CloseIcon from "@mui/icons-material/Close";
import "./add-new-campiagn.scss";
import { AlertComponent } from "../../../../common/components";
import { MassUpdateProps } from "../action-types";
import { Select, MenuItem, IconButton } from "@mui/material";
import PaginationComponent from "../../../../common/components/pagination-component/pagination-component";
import "../actions.scss";
import "../../../leads/lead-view/lead-view-details/lead-view-details-edit/lead-view-edit-view-full-info/lead-view-edit-view-full-info.scss";
import { makeStyles } from "@mui/styles";
import { getCampaigns } from "../../../../api/campaign";
import SearchInputComponent from "../../../../common/components/search-input-component/search-input-component";
import _ from "lodash";
import CampaignTable from "../../../../common/components/modal-table/modal-table";
import { CAMPAIGN_STATUS_OPTIONS } from "../../../../constants/campaignDropdown";
import { useNavigate } from "react-router-dom";
import AddCampaignPopup from "../add-campaign-popup/add-campiagn-popup";
import {
  campainAssignToCustomers,
  multiplecampainsAssignToCustomers,
} from "../../../../api/customer";

interface AddToCampaignModalProps {
  customerIds: number[];
  isOpen: boolean;
  setMenuItems: React.Dispatch<
    React.SetStateAction<{ value: string; id: number; isOpen: boolean }[]>
  >;
  selectedActions: string;
  handleMassActionMenuClose: () => void;
  multipleCampaign?: boolean;
  onSave?: () => void;
  hideAddCampaignButton?: any;
}

const AddToCampaignModal: React.FC<AddToCampaignModalProps> = ({
  customerIds,
  isOpen,
  setMenuItems,
  selectedActions,
  handleMassActionMenuClose,
  multipleCampaign,
  onSave,
  hideAddCampaignButton,
}) => {
  const [selectedField, setSelectedField] = useState<{
    label: string;
    id: number;
    value: string;
  }>({
    label: "",
    id: 0,
    value: "",
  });
  const [inputValue, setInputValue] = useState<string>("");
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [pageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0); // Set an initial value for testing
  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isResetSearch, setIsResetSearch] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const navigate = useNavigate();
  const isSearchTriggered = useRef(false);
  const [selectedCampaigns, setSelectedCampaigns] = useState<
    { id: number; name: string }[]
  >([]);

  const [isAddCampaignOpen, setIsAddCampaignOpen] = useState(false);

  const handleAddNewCampaign = () => {
    setIsAddCampaignOpen(true);
  };

  const handleCloseAddCampaign = () => {
    setIsAddCampaignOpen(false);
  };
  const handleSearch = _.debounce((text: string) => {
    isSearchTriggered.current = true;
    setCurrentPage(1);
    setSearchText(text);
  }, 500);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setCurrentPage(value);
  };

  const [statusFilter, setStatusFilter] = useState<string>("Planned");
  const [selectedCampaign, setSelectedCampaign] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const fetchCampaigns = async (
    page = 1,
    search: string = "",
    filters: any = {},
  ) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      const params: any = {
        limit: pageSize,
        offset: offset,
        status: ["Planning", "Active"],
      };
      if (search) {
        params.searchText = search;
      }
      const response = await getCampaigns(params, "View Campaigns");
      setData(response.data.data.result);
      setTotalRecords(response.data.data.totalRecords);
      setLoading(false);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to fetch campaigns",
      );
      setAlertType("error");
      setAlertOpen(true);
      setError(
        error?.response?.data?.message ||
          error?.response?.data?.message ||
          "Failed to fetch campaigns",
      );
      setLoading(false);
    }
  };
  const handleAlertClose = () => {
    setAlertOpen(false);
    setAlertMessage("");
  };
  const handleSave = async () => {
    if (
      (!multipleCampaign && (!selectedCampaign || customerIds.length === 0)) ||
      (multipleCampaign &&
        (selectedCampaigns.length === 0 || customerIds.length !== 1))
    ) {
      setAlertMessage("Please select valid campaign(s) and leads.");
      setAlertType("error");
      setAlertOpen(true);
      return;
    }

    setLoading(true);
    try {
      if (multipleCampaign) {
        await multiplecampainsAssignToCustomers(
          {
            actionScope: "singleCustomer_multiCampaign",
            campaignIds: selectedCampaigns.map((c) => c.id),
            customerId: customerIds[0],
            customerStatusInCampaign: statusFilter,
          },
          "Customer Profile",
        );
        onSave?.();

        setAlertMessage(
          selectedCampaigns.length === 1
            ? "Customer added to Campaign Successfully"
            : "Customer added to Campaigns Successfully",
        );
        setSelectedCampaigns([]);
      } else {
        await campainAssignToCustomers(
          {
            actionScope: "multiCustomer_singleCampaign",
            customerIds: customerIds,
            campaignId: selectedCampaign?.id!,
            customerStatusInCampaign: statusFilter,
          },
          "Customer Profile",
        );
        setAlertMessage(
          customerIds.length > 1
            ? `Customers successfully added to ${selectedCampaign?.name}`
            : `Customer successfully added to ${selectedCampaign?.name}`,
        );
      }

      setAlertType("success");
      setCurrentPage(1);
      setAlertOpen(true);
      setLoading(false);
      handleCancel();
    } catch (err: any) {
      setLoading(false);
      setAlertMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Failed to assign leads to campaign.",
      );
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      const pageToUse = isSearchTriggered.current ? 1 : currentPage;
      fetchCampaigns(pageToUse, searchText);
      isSearchTriggered.current = false;
    }
  }, [isOpen, currentPage, searchText]);

  const handleCancel = () => {
    setSelectedField({
      label: "",
      id: 0,
      value: "",
    });
    setInputValue("");
    setMenuItems((prevItems) =>
      prevItems.map((item) =>
        item.value === selectedActions
          ? { ...item, isOpen: !item.isOpen }
          : item,
      ),
    );
    handleMassActionMenuClose();
    setSelectedCampaign({ id: 0, name: "" });
    setSelectedCampaigns([]);
    setSearchText("");
    setStatusFilter("Planned");
    setLoading(false);
  };

  const useStyles = makeStyles(() => ({
    selected: {},
    rootMenuItem: {
      "&$selected": {
        backgroundColor: "transparent !important",
        "&:hover": {
          backgroundColor: "#8879501A !important",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        },
      },
    },
  }));
  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);
  const noResultsTxt = useMemo(() => {
    if (searchText) {
      return "No Campaigns found matching your search criteria.";
    }
    return "No Campaigns found";
  }, [searchText]);

  return (
    <div className="mass-update-wrapper">
      <Dialog
        open={isOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCancel();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="update-popup-wrapper"
        slotProps={{
          paper: {
            sx: {
              minWidth: "1000px",
              minHeight: "700px",
              borderBottomLeftRadius: "30px",
              borderBottomRightRadius: "30px",
              top: 0,
              margin: 0,
              position: "absolute",
            },
          },
        }}
      >
        <DialogTitle className="campaign-modal__header">
          <span>Add to Campaigns</span>
          <IconButton onClick={handleCancel}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="campaign-modal__content">
          <div className="campaign-modal__search-filter-wrapper">
            <div className="campaign-modal__search-filter">
              <SearchInputComponent
                placeholder="Search by Campaign name, Campaign owner"
                onSearch={handleSearch}
                isReset={isResetSearch}
              />
            </div>
            {!multipleCampaign && !hideAddCampaignButton && (
              <button
                className="add-campaign-button"
                onClick={handleAddNewCampaign}
              >
                New Campaign +
              </button>
            )}
          </div>

          <CampaignTable
            data={data}
            selectedCampaign={selectedCampaign}
            setSelectedCampaign={(campaign) => setSelectedCampaign(campaign)}
            multiple={multipleCampaign}
            selectedCampaigns={selectedCampaigns}
            setSelectedCampaigns={setSelectedCampaigns}
            noDataMessage={noResultsTxt}
          />

          <div className="campaign-modal__footer">
            <div className="campaign-modal__status-select">
              <span className="status-span">Status</span>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                size="small"
              >
                {CAMPAIGN_STATUS_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </div>

            {totalRecords && totalRecords > 0 ? (
              <div className="leads-pagination-container">
                <PaginationComponent
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <></>
            )}

            <div className="campaign-modal__action-buttons">
              <button onClick={handleCancel} className="cancel-button">
                Cancel
              </button>
              <button
                className="cancel-button next-button-wrapper"
                onClick={handleSave}
                disabled={
                  multipleCampaign
                    ? selectedCampaigns.length === 0
                    : selectedCampaign === null || selectedCampaign.id === 0
                }
              >
                {!multipleCampaign ? "Save" : "Add to Customers"}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <AddCampaignPopup
        open={isAddCampaignOpen}
        onClose={handleCloseAddCampaign}
        onSuccess={() => {}}
        onSuccessCallback={async (msg, type, newCampaign) => {
          setAlertMessage(msg);
          setAlertType(type);
          setAlertOpen(true);

          handleCloseAddCampaign();

          await fetchCampaigns(currentPage, searchText);

          if (newCampaign?.id) {
            setSelectedCampaign({
              id: newCampaign.id,
              name: newCampaign.name,
            });
          }
          setCurrentPage(1);
        }}
      />
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default AddToCampaignModal;
